import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";


import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";

const StockIn = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");
  const [ stockinData, setStockinData ] = useState([]) 
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery,setSearchQuery] = useState("")

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.STOCKINDETAILS}`, { state: { data: rowData } });
  }

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const apiCallFunction = () =>{
    fetchPoStockin()
  }

  useEffect(() => {
    fetchPoStockin()
  },[])

  const fetchPoStockin = async (page = 0, pageSize = 10) => {
    try{
      setLoading(true)
      const response = await axiosInstance.post("/Postockin/polist",{ page,
        pageSize,
      searchText:searchQuery}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      })

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        // "Sr No.": index + 1 + page * pageSize
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);
      setStockinData(formattedData)
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

    }catch(error){
      console.log(error)
    }
    finally{
      setLoading(false)
    }
  }

  const TABLE_HEADERS = [
    "PO No.",
    "PO Date",
    "PO Type",
   
    "Payment term",
    "Payment Mode",
    
    "Action",
  ];

  const keyMapping = {
    "PO No.":"po_number",
     "PO Date":"po_date",
     "PO Type":"potype",
     "Payment term":"payment_term_name",
     "Payment Mode":"payment_mode",
     "Status":"status",
     Action: [
       // { type: "edit", icon: editIcon, label: "Edit" },
       { type: "view", icon: eyeIcon, label: "View" },
     ],
   };

  const topDataList = [
    { id: 1, title: "Total  Item In-Stock", value: "180" },
    { id: 2, title: "Total Vehicle In-Stock", value: "170" },
    { id: 3, title: "Total Pending Item In-Stock", value: "8" },
    { id: 4, title: "Total Complete In-Stock", value: "2" },
   
  ];
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  }   

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
      isButtonRequired={false}
      headerTopText="Logistic / Stock In"
      headerTitle="Stock IN"
      listTitle="All Stock IN"
      topDetailsList={topDataList}
      tableData={stockinData}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleViewButton={handleViewDetails}
      itemsPerPage={10}
      currentPage={currentPage}
      totalPages={totalPages}
      totalRecords={totalRecords}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleSearchChange={handleSearchChange}
      handleKeyPress={handleKeyPress} 
      apiCallFunction={apiCallFunction}
      searchplaceholder="Search by PO Type" 
    />
           </div>
    )}
    </div>
  );
};

export default StockIn;
